import { Paper, Stack, type SxProps, Typography } from '@mui/material';
import { type ReactNode } from 'react';

interface Props {
    icon?: ReactNode;
    title: string;
    description: string;
    sx?: SxProps;
}

const Result = ({ icon, title, description, sx }: Props) => {
    return (
        <Paper
            variant="outlined"
            sx={{
                borderRadius: 3,
                px: { xs: 2.5, sm: 4 },
                py: { xs: 3, sm: 4.5 },
                borderColor: 'rgba(148, 163, 184, 0.24)',
                background:
                    'linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.94) 100%)',
                ...sx,
            }}
        >
            <Stack spacing={1.5} sx={{ alignItems: 'center', textAlign: 'center' }}>
                {icon && (
                    <Stack
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 64,
                            height: 64,
                            borderRadius: '20px',
                            color: 'primary.main',
                            backgroundColor: 'rgba(37, 99, 235, 0.08)',
                        }}
                    >
                        {icon}
                    </Stack>
                )}

                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {title}
                </Typography>

                <Typography color="text.secondary" sx={{ maxWidth: 560 }}>
                    {description}
                </Typography>
            </Stack>
        </Paper>
    );
};

export default Result;
